/*******************************************************************************
 * Copyright (c) 2025 Passport Fintech Inc. All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 ******************************************************************************/

import {environment as sharedEnvironment} from '@common-core/environments/environment.prod';
import {Environment} from '@shared/models/environment';

export const environment: Environment = {
  ...sharedEnvironment,
  dashboard: 'paas',
};
